import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AlertCircle, Zap, Calendar } from "lucide-react";

/**
 * CreditLimitModal - Aylık kredi limiti dolduğunda gösterilen modal
 * @param {Object} props
 * @param {boolean} props.isOpen - Modal visibility state
 * @param {Function} props.onClose - Close modal callback
 * @param {Object} props.creditStatus - Credit status object
 */
const CreditLimitModal = React.memo(({ 
  isOpen, 
  onClose, 
  creditStatus
}) => {
  const remainingCredits = creditStatus?.remaining_monthly_credits || 0;
  const monthlyLimit = creditStatus?.monthly_credits_limit || 1500;
  const usedCredits = creditStatus?.monthly_credits_used || 0;

  // Sonraki ayın adını hesapla
  const nextMonth = new Date();
  nextMonth.setMonth(nextMonth.getMonth() + 1, 1);
  const nextMonthName = nextMonth.toLocaleDateString('tr-TR', { month: 'long', day: 'numeric' });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" aria-label="Kredi Limiti">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-yellow-500" />
            Aylık Kredi Limitiniz Doldu
          </DialogTitle>
          <DialogDescription>
            Bu ay için tüm kredilerinizi kullandınız
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <Card className="p-4 bg-muted/50">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Kalan Kredi</span>
                <span className="font-bold text-lg flex items-center gap-1">
                  <Zap className="h-4 w-4 text-yellow-500" />
                  {remainingCredits}
                </span>
              </div>
              
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Kullanılan</span>
                <span className="font-medium">{usedCredits} / {monthlyLimit}</span>
              </div>
              
              <div className="w-full bg-secondary rounded-full h-2">
                <div 
                  className="bg-primary rounded-full h-2 transition-all"
                  style={{ width: `${Math.min(100, (usedCredits / monthlyLimit) * 100)}%` }}
                />
              </div>
            </div>
          </Card>
          
          <div className="flex items-start gap-3 p-3 rounded-lg bg-blue-50 dark:bg-blue-950/30">
            <Calendar className="h-5 w-5 text-blue-500 mt-0.5 shrink-0" />
            <p className="text-sm text-muted-foreground">
              Krediniz <span className="font-medium text-foreground">{nextMonthName}</span> tarihinde 
              otomatik olarak <span className="font-medium text-foreground">{monthlyLimit}</span> krediye yenilenecek.
            </p>
          </div>
          
          <Button variant="outline" className="w-full" onClick={onClose}>
            Anladım
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
});

CreditLimitModal.displayName = 'CreditLimitModal';

export default CreditLimitModal;
